import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { SelectChipOptionContainer } from "~/components/Select/components/SelectChipOptionContainer";
import { Select } from "~/components/Select/Select";
import { isKnownClipSource, SOURCE_MAP } from "~/constants/sourceMap";
const sourceToOption = (source)=>({
        value: source,
        label: isKnownClipSource(source) ? SOURCE_MAP[source] : source,
        borderRadius: 4
    });
export const SourcesSelect = /*#__PURE__*/ memo((param)=>{
    let { sources, selectedValues, onSelectionChange, ...props } = param;
    const options = useMemo(()=>sources.map((s)=>sourceToOption(s)), [
        sources
    ]);
    const selectedOptions = useMemo(()=>selectedValues.map((s)=>sourceToOption(s)), [
        selectedValues
    ]);
    const onValuesChange = useCallback((param)=>{
        let { chips } = param;
        onSelectionChange(chips.map((chip)=>chip.value));
    }, [
        onSelectionChange
    ]);
    const listItemRenderer = useCallback((option)=>/*#__PURE__*/ _jsx(SelectChipOptionContainer, {
            className: "flex justify-between py-2",
            children: /*#__PURE__*/ _jsx("p", {
                className: "text-14 text-grey-12",
                children: option.label
            })
        }), []);
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": "SOURCES_SELECT",
        placeholder: "Search upload sources",
        listItemRenderer: listItemRenderer,
        maxDropdownHeight: 300,
        options: options,
        renderAsInput: true,
        isSearchable: true,
        onSelectionChange: onValuesChange,
        selectedOptions: selectedOptions,
        alwaysShowClearItemButton: true,
        isClearable: true,
        isSticky: true,
        size: "large",
        ...props
    });
});
SourcesSelect.displayName = "SourcesSelect";
